import type { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './CodeEditorFallback.module.css';

export const CodeEditorFallback = ({ fullscreen, children }: { fullscreen?: boolean; children?: ReactNode }) => (
  <div className={clsx(styles.fallback, fullscreen && styles.fullscreen)}>{children}</div>
);
